/**
*
* Document
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import AddFile from 'components/interaction/AddFiles/AddFile/index.jsx';
import FormControlWrapper from 'components/interaction/Form4/FormControlWrapper.jsx';
import { intlLink } from 'utils/intlFunctions.jsx';
import { boolean, object } from 'yup';
import messages from './messages.js';

const statementLink = 'https://s3-eu-west-1.amazonaws.com/static.socialschools.eu/werkgeversverklaring.pdf';

function Document(props) {
  const { value, onChange, onBlur, ...rest } = props;
  if (!value) {
    return null;
  }
  const helpText = { ...messages.employedHelp, values: intlLink(statementLink, { target: '_blank' }) };
  const { handoverDocument, document } = value;

  function handleChange(key, v) {
    onBlur();
    onChange({ ...value, [key]: v });
  }

  return (
    <FormControlWrapper border={2} {...rest}>
      <Form.Text className="mb-3"><FormattedMessage {...helpText} /></Form.Text>
      {document?.fileName ? (
        <div className="my-2"><a href={document.fullPath} target="_blank">{document.fileName}</a></div>
      ) : (
        <div className="d-flex align-items-center justify-content-around">
          <Form.Check
            id="handover-document"
            checked={handoverDocument}
            type="checkbox"
            onChange={((ev) => handleChange('handoverDocument', ev.target.checked))}
            label={<FormattedMessage {...messages.handover} />}
          />
          <AddFile value={document} disabled={handoverDocument} className="btn btn-link my-2" onChange={(v) => handleChange('document', v)}><FormattedMessage {...messages.upload} /></AddFile>
        </div>
      )}
    </FormControlWrapper>
  );
}

Document.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};

Document.getSchema = (options, intl) => {
  const { required } = options;
  return object().shape({
    handoverDocument: boolean(),
    document: object(),
  }).label(intl.formatMessage(messages.document)).test('has-document', undefined, (value) => {
    if (!required) {
      return true;
    }
    const { handoverDocument, document } = value;
    return handoverDocument || Boolean(document?.fileName || document?.originalFileName);
  });
};

export default Document;
